import { RouteErrorBoundary } from "./ErrorBoundary";
import { File as FileComponent } from "./File";
import { loader } from "./loader";

export const File = {
  Component: FileComponent,
  ErrorBoundary: RouteErrorBoundary,
  loader,
};
